import {
    createSlice,
} from '@reduxjs/toolkit';

const initialState = {};

const bonuses = createSlice({
    name: 'bonuses',
    initialState,
    reducers: {
        setBonuses: (state, { payload }) => payload,
    },
});

export const {
    setBonuses,
} = bonuses.actions;

export default bonuses.reducer;
